import { Helmet } from "react-helmet";
import Hero from "../Modules/home/Hero";
import Mission from "../Modules/home/Mission";
import UniqueSellingPoint from "../Modules/UniqueSellingPoint";
import Usecases from "../Modules/home/Usecases";
import "../index.css"
import NavigationBar from "../Modules/NavigationBar";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../Modules/Footer";
import Product from "../Modules/home/Product";
import Testimonials from "../Modules/home/testimonials";
import Spacer from "../Modules/Spacer";

export default function Home() {

    return (
        <>
            <Helmet>
                <title>{"EarsOnly | Homepage"}</title>
            </Helmet>
            <NavigationBar />
            <Hero title="" video />
            <Container className="container-padding">

                <Row xs={1} sm={1} md={1} lg={2} >
                    <Col style={{ paddingBottom: "100px" }}>
                        <Product
                            img="/images/cradle_and_buds/ProtectOpenCradleWithBuds.png"
                            title="/images/logos/Protect.png"
                            text="True-Wireless custom fit hearing protection with dynamic damping. Ability to communicate in noisy environments and enjoy high quality music at safe sound levels."
                            preOrder={true}
                            orderLink="/contact"
                            moreLink="/protect"
                            bg="dark"
                        />
                    </Col>
                    <Col style={{ paddingBottom: "100px" }}>
                        <Product
                            img="/images/cradle_and_buds/REDUX_center.png"
                            title="/images/logos/Redux.png"
                            text="Redux earplugs are engineered for both professionals and dedicated enthusiasts who demand high performance and protection."
                            preOrder={false}
                            orderLink="/contact"
                            moreLink="/redux"
                            bg="light"
                        />
                    </Col>
                </Row>
                <Spacer height="100px" />
                <Mission />
                <Spacer height="100px" />
                <UniqueSellingPoint
                    image="/images/highlighticons/Dopple-inside.png"
                    title="Powered by Dopple"
                    text="Advanced audio protection technology platform designed and engineered in-house to deliver precision performance, reliable protection, and intelligent sound processing."
                />
                <Spacer height="100px" />
                <Testimonials />
            </Container>
            <Footer />
        </>
    )
};
